import { brandInfo } from "../../../constant";

export const AdminFooter = () => {
  return (
    <div className="footer">
      &copy; {brandInfo.name.capital} | All Rights Reserved
    </div>
  );
};
